import { Injectable, Inject, InjectionToken } from '@angular/core';

import { EstensaBusWrapperService } from './estensa-bus-wrapper.service';

export const ESTENSA_MODULE_PRINT_CONFIGURATION_SERVICE = new InjectionToken('estensa.module.print.configuration.service');

export abstract class PrintPdfService {
    abstract print(pdfData: ArrayBuffer | Uint8Array);
}

@Injectable({
    providedIn: 'root',
})
export class EstensaPrintService extends PrintPdfService {

    // data members

    private _printConfiguration;

    // constructor

    constructor(
        private estensaBusWrapperService: EstensaBusWrapperService,
        @Inject(ESTENSA_MODULE_PRINT_CONFIGURATION_SERVICE) private printConfigurationService) {
            super();
            this._printConfiguration = this.printConfigurationService.getClientConfiguration();
    }

    // ArrayBuffer for browsers different than IE11
    // string for IE11
    print(pdfData: ArrayBuffer | Uint8Array) {

        let buffer = pdfData instanceof Uint8Array ? pdfData.buffer : pdfData;

        //let pdfObject;

        // if (pdfData instanceof ArrayBuffer) {
            // Chrome / Firefox => PDF
            //pdfObject = this._printConfiguration.transformResponse(pdfData.buffer);
        // }
        // else {
        //     // IE => JSON
        //     pdfObject = this._printConfiguration.transformResponse(JSON.stringify(pdfData));
        // }

        this.estensaBusWrapperService.notify({
            messageType: 'NG2_PRINT_MESSAGE',
            data: {
                buffer: buffer,
                preview: true,
                printer: "DEFAULT"
            }
        });
    }
}
